import type { ChargeQuoteLine } from './useSubmittedChargeQuote'

/** Why a quoted line carries the charge it does (PD-1597); shown in the breakdown and, for a refusal, on the Save gate (PD-1647). */
export const REASON_COPY: Record<NonNullable<ChargeQuoteLine['reason']>, string> = {
  'no-catalog-price': 'No price for this code in Settings › Terminology',
  'credential-not-recorded': 'Credential not recorded — NP/PA rate applied',
  'credential-cannot-bill': 'This credential cannot bill physician E/M codes',
  'patient-under-18': 'Pediatric billing is out of scope',
}

/**
 * The copy for a quoted line. An unrecorded credential is priced at the NP/PA
 * tier, except in an organization whose fee policy has switched that tier off —
 * then the line is unpriced and must not claim a rate was applied (PD-1690).
 */
export function reasonCopy(
  line: Pick<ChargeQuoteLine, 'reason' | 'submittedCharge'> | undefined,
): string | undefined {
  if (!line?.reason) return undefined
  if (line.reason === 'credential-not-recorded' && line.submittedCharge === null) {
    return 'Credential not recorded — no rate applies until a licence is recorded'
  }
  return REASON_COPY[line.reason]
}
